import Image from "next/image";

export const CompanyTrustBanner: React.FC = () => {
    return (
        <section className="flex flex-col mx-auto">
            <div className="max-w-7xl px-4 client-logos flex flex-col gap-3 mx-auto">
                <Image width={221} height={56} src="/frame.png" alt={"Frame"} className="flex-shrink" />
                <div className="lg:flex justify-between items-center">
                    <h3 className="text-2xl lg:text-3xl font-semibold text-gray-900 mb-14">
                        Trusted by over <span className="font-bold">10,000 companies</span> across <span className="font-bold">40+ </span> countries
                    </h3>
                    <div className="flex justify-center mb-9">
                        <Image
                            width={730}
                            height={56}
                            src="https://assets.gallabox.com/gb-home/e-book/logo-image.png"
                            alt="client-logo-data"
                            className="flex-shrink lg:block hidden"
                        />
                        <Image width={730} height={56} src="https://assets.gallabox.com/gb-home/e-book/logo-image.png" alt="client-logo-data" className="flex-shrink lg:hidden" />
                    </div>
                </div>
            </div>
        </section>
    );
};
